export const useDomainEngagementData = ({
  pDistChange,
  eDistChange,
  aDistChange,
  rDistChange,
  lDistChange,
  iDistChange,
}) => {
  const domains = [
    ["Physical", pDistChange],
    ["Emotional", eDistChange],
    ["Acceptance", aDistChange],
    ["Relationships", rDistChange],
    ["Loving-Kindness", lDistChange],
    ["Intelligence", iDistChange],
  ];

  const safeSum = (arr) =>
    Array.isArray(arr) && arr.length > 0
      ? arr.reduce((sum, [, values]) => sum + (values?.[0] || 0), 0)
      : 0;

  const totalPrev = safeSum(domains.map(([_, arr]) => ["", arr]));
  const totalCurr = domains.reduce((sum, [, arr]) => sum + (arr?.[1] || 0), 0);
  const totalDiff = totalCurr - totalPrev;
  const totalColor =
    totalDiff > 0 ? "#19B880" : totalDiff === 0 ? "#334155" : "#EF4444";

  return { domains, totalPrev, totalCurr, totalDiff, totalColor };
};
